import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";

import { getListOfCategoriesForDocUploadUserQuery, downloadGridById } from "../../services/graphql/queries/category-management";
import { getAccessPermisionQuery } from "../../services/graphql/queries/accessPermission";
import { getListofGenericMasterQuery } from "../../services/graphql/queries/user";

import { errorMessage } from "../../miscellaneous/error-messages";
import { errorMsg } from "../../miscellaneous/react-toastify";

import Pagination from "../Common/Pagination";
import NotAccessible from "../Common/NotAccessible";
import ReactModal from "../Common/ReactModal";


import { PAGINATION_OFFSET_VALUE, DO_NOT_ACCESS_MESSAGE }  from "../../constants/app-constants";
import CategoryFilter from "./CategoryFilter";

const FileSaver = require("file-saver");
const mime = require("mime-types");

const CATEGORY_MANAGEMENT_MODULE_ID = 7;
const CATEGORY_MANAGEMENT_FEATURE_ID = 190;

class CategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error:"",
      pageOfItems:[],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      showFilter: false,
      isFilterApply: false,
      filterData: {},
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: DO_NOT_ACCESS_MESSAGE,
      accessSpecifier: {}
    };
    this.submitModal = this.submitModal.bind(this);
    this.filterAction = this.filterAction.bind(this);
    this.onFilterData = this.onFilterData.bind(this);
  }

  submitModal() {
    this.setState({ reactModalVisible: false });
  }

  onAddCategory() {
    this.props.client
      .query({
        query: downloadGridById,
        variables: {
          gridId: 2
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let document = result.data.downloadGridReport;
        document = JSON.parse(document)
        var byteCharacters = atob(document.fileData);

        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        const contentType = mime.lookup(document.fileName.split(".")[1]);

        var blob = new Blob([byteArray], {
        type: contentType
        });

        FileSaver.saveAs(blob, document.fileName);
      })
      .catch(error => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  onFilterData(data, isFilterApply) {
    this.setState({
      isFilterApply: isFilterApply,
      filterData: data,
      currentPage: 1
    });
    if (isFilterApply) {
      this.getListOfCategory(this.state.offset, 1, data);
    } else {
      this.setState({
        filterData: {}
      });
      this.getListOfCategory(this.state.offset, 1);
    }
  }

  filterAction() {
    this.setState(prevState => {
      return {
        showFilter: !prevState.showFilter
      };
    });
  }

  onChangePage(currentPage) {
    // update state with new page of items
        this.setState({
      currentPage: currentPage,
      loading: true,
    },()=>{
      if (this.state.isFilterApply) {
        this.getListOfCategory(
          this.state.offset,
          currentPage,
          this.state.filterData
        );
      } else {
        this.getListOfCategory(this.state.offset, currentPage);
      }
    });
  }

  getListOfCategory(offset, pageNo, data){
    this.props.client
      .query({
        query: getListOfCategoriesForDocUploadUserQuery,
        variables: {
          offset: offset,
          pageNo: pageNo,
          id: data && data.id ? data.id : null,
          name: data && data.name ? data.name.trim() : "",
          // status: data && data.status ? data.status : null,
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        var category = result.data.getListOfCategoriesForDocUploadUser;
        
        this.initialState = {
          pageOfItems: category
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch(error => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount(){
    this.setState({
      loading: true
    });

    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: CATEGORY_MANAGEMENT_MODULE_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response[CATEGORY_MANAGEMENT_FEATURE_ID]
        });
        this.getListOfCategory(this.state.offset, this.state.currentPage);   
      })
      .catch(error => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({
          loading: false,
          error: error.message
        });
      });
  }

  render() {
    const {
      loading,
      error,
      accessSpecifier,
      reactModalVisible,
      requireCancel,
      modalMessage,
      pageOfItems,
    } = this.state;
    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
        <>
        {console.log("accessSpecifier",accessSpecifier)}
          {accessSpecifier && accessSpecifier.viewP ? (
          <div>
            <ReactModal
              reactModalVisible={reactModalVisible}
              submitModal={this.submitModal}
              modalMessage={modalMessage}
              requireCancel={requireCancel}
            />
            <div className="row align-items-center no-gutters">
                <div className="col-md-8">
                    <h1 className="heading m-b-0">Project List - Upload  </h1>
                </div>
                <div className="col-md-4 text-right">
                    {/* <a href="#" className="btn btn-danger" onClick={() => this.onAddCategory()}>Download</a> */}
                    <button className="btn btn-primary filter-btn  m-l-10" onClick={this.filterAction}>Filter</button>
                    <CategoryFilter 
                        showFilter={this.state.showFilter}
                        filterData={this.state.filterData}
                        listData={this.onFilterData}
                        filterAction={this.filterAction}
                    />
                </div>
            </div>
            <div className="table-responsive">
                <table className="table table-style-1 m-t-35">
                    <thead>
                        <tr>
                            <th style={{width:'250px'}}>PROJECT ID</th>
                            <th scope="col">NAME</th>
                            <th style={{width:'150px'}}>DISPLAY ORDER</th>
                            {/* <th scope="col">STATUS</th> */}
                            <th style={{width:'100px'}}>ACTION(s)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageOfItems.length ?
                          pageOfItems.map((data,index)=>{
                            return(
                              <tr key={index}>
                                <td>{data.projectId}</td>
                                <td>{data.name}</td>
                                <td>{data.displayOrder}</td>
                                {/* <td>{data.status}</td> */}
                                <td><a href={"/category-document-upload-detail?id="+data.id} 
                                onClick={()=> localStorage.setItem("docUploadCategoryId",data.id)}
                                className="link-primary" data-toggle="tooltip" data-placement="bottom" title="View">
                                    <svg x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
                                    <g transform="translate(0, 0)">
                                        <line fill="none" stroke="#69951a" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} x1="4.5" y1="11.5" x2="11.5" y2="11.5" data-color="color-2" />
                                        <line fill="none" stroke="#69951a" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} x1="4.5" y1="8.5" x2="11.5" y2="8.5" data-color="color-2" />
                                        <line fill="none" stroke="#69951a" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} x1="4.5" y1="5.5" x2="6.5" y2="5.5" data-color="color-2" />
                                        <polygon fill="none" stroke="#69951a" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 " />
                                        <polyline fill="none" stroke="#69951a" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} points="9.5,0.5 9.5,5.5 14.5,5.5 " />
                                    </g>
                                    </svg>
                                  </a>
                                </td>
                              </tr>
                            )
                          })
                          :null}
                    </tbody>
                </table>
            </div>
            {!pageOfItems.length && error ? <div>{error}</div> : null}
            {!pageOfItems.length && loading ? <div>Fetching...</div> : null}
            {!pageOfItems.length && !error && !loading ? (
            <div style={{ textAlign: "center" }}>No Data</div>
            ) : null}

              <div className="row">
                <div className="col-md-2">
                </div>
                <div className="col-md-8">
                  <Pagination
                      loading={loading}
                      items={pageOfItems}
                      pageSize={this.state.offset}
                      initialPage={this.state.currentPage}
                      onChangePage={this.onChangePage.bind(this)}
                  />
                </div>
                <div className="col-md-2 form-group" style={{display: 'flex', marginTop: '8px'}}>
                  <label style={{marginTop: '8px'}}>Page Size: </label>
                  <select
                    className="form-control"
                    style={{width: '65px'}}
                    onChange={e => {
                      this.setState({ offset: parseInt(e.target.value)},
                      ()=>{
                        this.getListOfCategory(this.state.offset, this.state.currentPage);
                      }
                      );
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>
            
          </div>
        ) : (
          <NotAccessible />
        )}
        </>
    );
  }
}
export default withRouter(withApollo(CategoryList));